module.exports = __webpack_public_path__ + "img/message.6daf4977.svg";